import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';

const ImpressumPage: React.FC = () => {
  return (
    <div className="pt-24 pb-16">
      <Helmet>
        <title>Impressum - Easy Vertrag | Rechtliche Informationen</title>
        <meta name="description" content="Impressum von Easy Vertrag. Anbieter: Easy Vertrag, Bismarck Straße 31, 66333 Völklingen. Tel: +49 179 7473491." />
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href="https://easy4vertrag.de/impressum" />
      </Helmet>
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <div className="mb-12 flex items-center justify-center">
            <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center">
              <FileText className="w-8 h-8 text-blue-600" />
            </div>
          </div>

          <h1 className="text-3xl font-bold text-center mb-8">Impressum</h1>
          
          <div className="bg-white rounded-lg shadow-md p-8">
            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Adresse</h2>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-700">
                  Easy Vertrag Einzelunternehmen<br />
                  Bismarck Straße 31<br />
                  66333 Völklingen<br />
                  Deutschland<br />
                  Ust-ID-Nr.: DE 366 651 610
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Kontakt</h2>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-700">
                  Telefon: +49 179 7473491<br />
                  E-Mail: easy90az@gmail.com<br />

                  Öffnungszeiten:<br />
Mo-Fr : 10.00-20.00 Uhr<br />
Sa    : 10.00-18.00 Uhr<br />
So    : geschlossen
                </p>
              </div>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Vertreten durch</h2>
              <p className="text-gray-700 mb-4">
                Geschäftsführung: Zaher Abdullah
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Umsatzsteuer-ID</h2>
              <p className="text-gray-700 mb-4">
                Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
                [DE 366 651 610]
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Streitschlichtung</h2>
              <p className="text-gray-700 mb-4">
                Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: 
                <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                  https://ec.europa.eu/consumers/odr/
                </a>
                <br /><br />
                Unsere E-Mail-Adresse finden Sie oben im Impressum.
              </p>
              <p className="text-gray-700 mb-4">
                Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle teilzunehmen.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Haftung für Inhalte</h2>
              <p className="text-gray-700 mb-4">
                Als Vermittler bzw. Vertriebspartner sind wir für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen verantwortlich. wir sind als Vertriebspartner jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-800 mb-4">Haftung für Links</h2>
              <p className="text-gray-700 mb-4">
                Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich.
              </p>
              <div className="mt-6">
                <p className="text-gray-700 mb-4">
                  <strong>CHECK24.net Partnerprogramm</strong>
                </p>
                <p className="text-gray-700 mb-4">
                  Wir nehmen am CHECK24.net Partnerprogramm teil. Auf unseren Seiten werden iFrame-Buchungsmasken und andere Werbemittel eingebunden, an denen wir über Transaktionen, zum Beispiel durch Leads und Sales, eine Werbekostenerstattung erhalten können.
                </p>
                <p className="text-gray-700 mb-4">
                  Weitere Informationen zur Datennutzung durch CHECK24.net erhalten Sie in der Datenschutzerklärung von <a href="https://www.check24.net" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">CHECK24.net</a>.
                </p>
              </div>
            </section>
          </div>

          <div className="mt-12 text-center">
            <Link 
              to="/kontakt" 
              className="inline-flex items-center justify-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors duration-300"
            >
              Bei Fragen kontaktieren Sie uns
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpressumPage;